export default __webpack_public_path__ + "static/media/pinterest.59105820.svg";